import React from 'react';
import { useTranslation } from 'react-i18next';
import { InformationMessageToastStyles } from './questionMessage.style';

export const QuestionMessage = ({ message }) => {
  const { t } = useTranslation();
  return (
    <InformationMessageToastStyles
      isVisible
      animate={false}
      isChildren={false}
      variant={'info'}
      header={t('attention')}
      message={message}
    />
  );
};
